import React from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Copy, ArrowLeft } from "lucide-react";
import { PRIMARY_URL, BACKUP_URL } from "@/lib/backendUrl";

const FIXES = [
  { t: "Use the backup link", d: "Some work, school or hotel networks, and some phone security filters, block websites that are only a few months old. The backup address runs the exact same app and keeps your account." },
  { t: "Try another browser", d: "Open the link in Chrome, Safari, Firefox or Edge — whichever you aren't using now. Some browsers have built-in data savers or proxies that block new sites." },
  { t: "Reset Private DNS / content filters", d: "Android: Settings → Network & internet → Private DNS → Automatic. iPhone: Settings → Screen Time → Content & Privacy → allow all websites, and turn off iCloud Private Relay." },
];

const LinkRow = ({ label, url, id }) => (
  <div className="p-4 rounded-xl border border-[#1E2638] bg-[#121620] flex items-center justify-between gap-3">
    <div className="min-w-0">
      <div className="text-[10px] font-mono uppercase tracking-widest text-[#64748B]">{label}</div>
      <a href={url} data-testid={`help-${id}-link`} className="text-[#00F0FF] break-all font-bold">{url.replace("https://", "")}</a>
    </div>
    <button data-testid={`help-${id}-copy`} aria-label={`Copy ${label}`}
      onClick={() => navigator.clipboard.writeText(url).then(() => toast.success("Copied")).catch(() => {})}
      className="p-2 rounded-lg border border-[#2A354B] hover:border-[#00F0FF] text-white flex-shrink-0"><Copy className="w-4 h-4" /></button>
  </div>
);

export default function HelpPage() {
  return (
    <div className="min-h-screen bg-[#0B0E14] text-white px-6 py-12" data-testid="help-page">
      <div className="max-w-xl mx-auto space-y-8">
        <Link to="/" className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-[#94A3B8] hover:text-[#00F0FF]" data-testid="help-back"><ArrowLeft className="w-3 h-3" />NeuralDeck</Link>
        <div className="space-y-3">
          <h1 className="font-display font-black text-4xl sm:text-5xl leading-tight">Can't open <span className="text-[#00F0FF]">NeuralDeck</span>?</h1>
          <p className="text-[#94A3B8]">Seeing “This site can't be reached”, DNS_PROBE_FINISHED_NXDOMAIN or ERR_TUNNEL_CONNECTION_FAILED? It's your network, not your phone being broken. Try these in order.</p>
        </div>
        <div className="space-y-3">
          <LinkRow label="Main address" url={PRIMARY_URL} id="primary" />
          <LinkRow label="Backup address — same app, same account" url={BACKUP_URL} id="backup" />
        </div>
        <ol className="space-y-4">
          {FIXES.map((f, i) => (
            <li key={f.t} className="flex gap-4" data-testid={`help-fix-${i + 1}`}>
              <div className="w-8 h-8 rounded-full bg-[#00F0FF] text-black font-black flex items-center justify-center flex-shrink-0">{i + 1}</div>
              <div><div className="font-black">{f.t}</div><div className="text-sm text-[#94A3B8]">{f.d}</div></div>
            </li>
          ))}
        </ol>
        <p className="text-xs text-[#64748B] font-mono">Still stuck? Screenshot the error with the address bar visible and send it to the DJ who shared the link.</p>
      </div>
    </div>
  );
}
